module.exports = __webpack_public_path__ + "assets/src/style/img/svg/icons/category-film.svg?cab4ff6a4efeb38bb0f9eb9c48fba3e9";